/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "A",
    asset: "TÀI SẢN",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "I",
    sttBold: false,
    asset: "Tiền mặt, vàng bạc, đá quý",
    assetBold: false,
    presentReadOnly: false,
    readOnly: false,
    presentBold: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "II",
    sttBold: false,
    asset: "Tiền gửi tại NHNN",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "II", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "III",
    sttBold: false,
    asset: "Tiền, vàng gửi tại các TCTD khác và cho vay các TCTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "III", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "IV",
    sttBold: false,
    asset: "Chứng khoán kinh doanh",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "IV", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "V",
    sttBold: false,
    asset: "Các công cụ tài chính phái sinh và các tài sản tài chính khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "V", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "VI",
    sttBold: false,
    asset: "Cho vay khách hàng",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VI", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "VII",
    sttBold: false,
    asset: "Chứng khoán đầu tư",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VII", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "VIII",
    sttBold: false,
    asset: "Góp vốn, đầu tư dài hạn",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VIII", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "IX",
    sttBold: false,
    asset: "Tài sản cố định",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "IX", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "X",
    sttBold: false,
    asset: "Bất động sản đầu tư (Báo cáo tài chính hợp nhất)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "X", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "XI",
    sttBold: false,
    asset: "Tài sản Có khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "XI", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "",
    sttBold: true,
    asset: "Tổng tài sản có",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "B",
    sttBold: true,
    asset: "Nợ phải trả và vốn chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 14,
    stt: "I",
    sttBold: false,
    asset: "Các khoản nợ Chính phủ và NHNN",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "I", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "II",
    sttBold: false,
    asset: "Tiền gửi và vay các TCTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "II", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "III",
    sttBold: false,
    asset: "Tiền gửi của khách hàng",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "III", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "IV",
    sttBold: false,
    asset: "Các công cụ tài chính phái sinh và các khoản nợ tài chính khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "IV", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "V",
    sttBold: false,
    asset: "Vốn tài trợ, ủy thác đầu tư, cho vay TCTD chịu rủi ro",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "V", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "VI",
    sttBold: false,
    asset: "Phát hành giấy tờ có giá",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VI", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "VII",
    sttBold: false,
    asset: "Các khoản nợ khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VII", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "",
    sttBold: false,
    asset: "Tổng nợ phải trả",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "VIII",
    sttBold: false,
    asset: "Vốn và các quỹ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "VIII", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "IX",
    sttBold: false,
    asset: "Lợi ích của cổ đông thiểu số",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "IX", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "",
    sttBold: false,
    asset: "Tổng nợ phải trả và vốn chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic" fontWeight="bold">
          Đơn vị tính: triệu đồng VN
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                STT
              </Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối quý</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="now"
                      readOnly={rows.readOnly}
                      value={rows.value.now}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="before"
                      readOnly={rows.readOnly}
                      value={rows.value.before}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
